import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import "./projectContent.css";
import "./projectContentMobile.css";
import "./projectContentLaptop.css";
import "./projectContentBlock.css";

import Image from "../../../components/image/image";

import Spacer from "./projectContentTypes/spacer/spacerContainer";
import TextBlock from "./projectContentTypes/text/textContainer";
import ImageBlock from "./projectContentTypes/image/imageContainer";
import ImagesBlock from "./projectContentTypes/images/imagesContainer";
import VideoBlock from "./projectContentTypes/video/videoContainer";
import EmbeddedVideoBlock from "./projectContentTypes/embeddedVideo/embeddedVideoContainer";

class ProjectContent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      correctPassword: false,
    };

    this.generateEmbeddedVideo = this.generateEmbeddedVideo.bind(this);
    this.generateContentBlocks = this.generateContentBlocks.bind(this);
    this.handlePasswordSubmit = this.handlePasswordSubmit.bind(this);
  }

  generateEmbeddedVideo(url) {
    const generateIframe = (service, videoId) => {
      const youtubeUrl = "https://www.youtube.com/embed/";
      const vimeoUrl = "https://player.vimeo.com/video/";
      if (service === "vimeo") {
        return (
          <div className="contentBlock embeddedVideo vimeo hero-video">
            <iframe
              src={`${vimeoUrl}${videoId}`}
              frameBorder="0"
              allowFullScreen
              title={`Vimeo Video ${videoId}`}
            />
          </div>
        );
      }
      return (
        <div className="contentBlock embeddedVideo YouTube hero-video">
          <iframe
            src={`${youtubeUrl}${videoId}`}
            modestbranding="1"
            frameBorder="0"
            allowFullScreen
            title={`Youtube Video ${videoId}`}
          />
        </div>
      );
    };

    // determine which service is being used
    const service =
      url.toLowerCase().indexOf("vimeo") > 0 ? "vimeo" : "youtube";
    // find id if correctly formatted youtube or vimeo url
    const video_id_regExp =
      /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    const match = url.match(video_id_regExp);
    let video_id = "";

    if (match && match[7]) {
      video_id = match[7];
      return generateIframe(service, video_id);
    }
    return (
      <div>
        <p>
          Error: ID could not be found in provided Youtube or Vimeo URL, please
          use formats: "https://vimeo.com/266464074" or
          "https://www.youtube.com/watch?v=qEoRo8rGgVY"
        </p>
      </div>
    );
  }

  generateContentBlocks() {
    let firstImageGenerated = false;
    if (this.props.project.fields.contentBlocks.length > 0) {
      return this.props.project.fields.contentBlocks.map(
        (contentBlock, index) => {
          // check to make sure object is a content block
          if (contentBlock.sys.contentType === undefined) {
            return <div key={index} />;
          }
          switch (contentBlock.sys.contentType.sys.id) {
            case "text":
              return <TextBlock data={contentBlock.fields} key={index} />;
            case "imageBlock":
              if (!firstImageGenerated) {
                firstImageGenerated = true;
                return (
                  <ImageBlock
                    data={contentBlock.fields}
                    key={index}
                    handleImageCreate={this.props.handleImageCreate}
                    handleImageLoaded={this.props.handleImageLoad}
                  />
                );
              }
              return <ImageBlock data={contentBlock.fields} key={index} />;

            case "imagesBlock":
              if (!firstImageGenerated) {
                firstImageGenerated = true;
                return (
                  <ImagesBlock
                    data={contentBlock.fields.images}
                    key={index}
                    handleImageCreate={this.props.handleImageCreate}
                    handleImageLoaded={this.props.handleImageLoad}
                  />
                );
              }
              return (
                <ImagesBlock data={contentBlock.fields.images} key={index} />
              );

            case "videoBlock":
              return <VideoBlock data={contentBlock.fields} key={index} />;
            case "embeddedVideoBlock":
              return (
                <EmbeddedVideoBlock data={contentBlock.fields} key={index} />
              );
            case "spacerContentBlock":
              return <Spacer key={index} />;
            default:
              return <div key={index} />;
          }
        },
      );
    }
    return <div />;
  }

  handlePasswordSubmit(event) {
    if (event.target.value === this.props.project.fields.password) {
      this.setState({
        correctPassword: true,
      });
    }
  }

  render() {
    if (
      this.props.project.fields.passwordProtected === true &&
      this.state.correctPassword === false
    ) {
      return (
        <div className="project password-protected-container">
          <button onClick={this.props.handleClick}>
            <div href="/">HOME</div>
          </button>
          <div className="password-protected">
            <input type="password" onChange={this.handlePasswordSubmit} />
            <h1>PASSWORD</h1>
          </div>
          <div className="requestPassword">
            <p>
              <a
                href={`mailto:nick@nickmiller.tv?subject=Requesting%20Password%20for%20${
                  this.props.project.fields.title
                }%20Project&body=Requesting%20password%20for%20${
                  this.props.project.fields.title
                }%20Project`}
              >
                Request Password →
              </a>
            </p>
          </div>
        </div>
      );
    }
    console.log(this.props.project);
    return (
      <div className="project">
        <button onClick={this.props.handleClick}>
          <div href="/">HOME</div>
        </button>
        {this.props.project.fields.heroType === "Autoplay Video" && (
          <div className="hero-autoplay-video">
            <video
              autoPlay
              loop
              muted
              src={this.props.project.fields.heroVideo.fields.file.url}
            />
          </div>
        )}
        {this.props.project.fields.heroType === "Image" && (
          <Image
            className="hero-image"
            src={this.props.project.fields.heroImage.fields.file.url}
            alt="alternative text"
            handleImageCreate={this.props.handleImageCreate}
            handleImageLoaded={this.props.handleImageLoad}
          />
        )}
        {this.props.project.fields.heroType === "Embedded Video" &&
          this.generateEmbeddedVideo(
            this.props.project.fields.heroEmbeddedVimeo,
          )}
        <div className="information">
          <h1 className="display-font title">
            {this.props.project.fields.title}
          </h1>
          <p className="body-font role">
            {this.props.project.fields.projectRole}
          </p>
          <div className="client body-font">
            {this.props.project.fields.clientImage ? (
              <Image
                src={this.props.project.fields.clientImage.fields.file.url}
                alt="Client Logo"
              />
            ) : (
              <p>{this.props.project.fields.client}</p>
            )}
          </div>
        </div>
        <div className="description body-font">
          <p>{this.props.project.fields.description}</p>
        </div>
        {this.props.project.fields.contentBlocks !== undefined ? (
          <div className="contentBlocks">{this.generateContentBlocks()}</div>
        ) : (
          <div />
        )}
        <div className="footerBiography">
          <div className="colophon body-font">
            <div className="links">
              <ul>
                <li>
                  <a
                    href="https://www.linkedin.com/in/nick-miller-8bb159a5/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/nickmillerworks"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </li>
              </ul>
            </div>
            <div className="copyright">
              &copy; Nick Miller {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ProjectContent;
